var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColumnsO(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.571429 0H15.4286C15.7446 0 16 0.325 16 0.727273V15.2727C16 15.675 15.7446 16 15.4286 16H0.571429C0.255357 16 0 15.675 0 15.2727V0.727273C0 0.325 0.255357 0 0.571429 0ZM5.07143 1.63636H1.28571V14.3636H5.07143V1.63636ZM6.21429 1.63636H9.78571V14.3636H6.21429V1.63636ZM14.7143 1.63636H10.9286V14.3636H14.7143V1.63636Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnsO);
export default __webpack_public_path__ + "static/media/columns-o.32e9c0e97c76f8d87cd902a7977494e3.svg";
export { ForwardRef as ReactComponent };